import 'regenerator-runtime';
import Chart from 'chart.js';
import { mark } from 'regenerator-runtime';

const code = sessionStorage.getItem('code');
const country = sessionStorage
  .getItem('country')
  .replace(/ /g, '-')
  .toLowerCase()
  .trim();
const mapid = document.querySelector('#mapid');
const sectionLive = document.querySelector('.section-cases');

// Section top

const sectionTop = document.querySelector('.section-top');

const getLive = async (country) => {
  try {
    console.log(country);
    const res1 = await fetch(
      `https://api.covid19api.com/live/country/${country}/status/confirmed`
    );
    const data1 = await res1.json();
    const data2 = data1.flat().filter((el) => {
      return !el.Province;
    });

    if (data2.length === 0) {
      const acc = {
        Confirmed: 0,
        Deaths: 0,
        Active: 0,
        Recovered: 0,
      };
      const data3 = data1.forEach((el) => {
        acc.Confirmed += el.Confirmed;
        acc.Deaths += el.Deaths;
        acc.Active += el.Active;
        acc.Recovered += el.Recovered;
      });

      return acc;
    }

    return data2[data2.length - 1];
  } catch (err) {
    console.log(err);
  }
};

const renderCasesSecion = async (data) => {
  data = await data;

  let markup;

  if (!data) {
    markup = `Unable to get data from API`;
  } else {
    markup = `
    <div class="info">
        <div class="new">
          <div class="confirmed">
            <i class="fas fa-virus"></i> Confirmed: ${data.Confirmed}
          </div>
          <div class="deaths">
            <i class="fas fa-skull-crossbones"></i> Deaths: ${data.Deaths}
          </div>
          <div class="recovered">
            <i class="fas fa-virus-slash"></i> Recovered:
            ${data.Recovered}
          </div>
          <div class="active">
            <i class="fas fa-heartbeat"></i> Active: ${data.Active}
          </div>
        </div>
      </div>
  `;
  }

  sectionLive.insertAdjacentHTML('beforeend', markup);
};

const getData = async (country) => {
  try {
    const res1 = await fetch(
      `https://api.covid19api.com/dayone/country/${country}/status/confirmed`
    );
    const res2 = await fetch(
      `https://api.covid19api.com/dayone/country/${country}/status/recovered`
    );
    const res3 = await fetch(
      `https://api.covid19api.com/dayone/country/${country}/status/deaths`
    );

    console.log(res3);

    if (res1.status !== 200 || res2.status !== 200 || res3.status !== 200) {
      alert('There was an error with api');
    }

    const data1 = await res1.json();
    const data2 = await res2.json();
    const data3 = await res3.json();

    if (!data1 || !data2 || !data3) return;

    return [data1, data2, data3];
  } catch (err) {
    throw new Error(err);
  }
};

const getCoords = async (country) => {
  try {
    const res = await fetch(
      `https://api.covid19api.com/dayone/country/${country}/status/confirmed`
    );
    const data = await res.json();
    return [+data[0].Lat, +data[0].Lon];
  } catch (err) {
    throw new Error(err);
  }
};

const getCountry = async (code) => {
  try {
    const res = await fetch(`https://restcountries.eu/rest/v2/alpha/${code}`);
    const data = await res.json();

    const html = `
    <img src="${data.flag}" alt="Flag" />
      <div class="content">
        <h1 class="heading">${data.name}</h1>
        <h3 class="h3">Capital: <span class="light">${data.capital} 🌇</span></h3>
        <h3 class="h3">
          Population: <span class="light">${data.population} 👨‍👨‍👦‍👦</span>
        </h3>
        <h3 class="h3">Currencies: <span class="light">${data.currencies[0].code} 💵</span></h3>
      </div>
  `;

    sectionTop.insertAdjacentHTML('afterbegin', html);
  } catch (err) {
    throw new Error(err);
  }
};

const generateMap = async (cords) => {
  try {
    cords = await cords;

    if (!cords) return;

    let map = L.map('mapid').setView([cords[0], cords[1]], 6);
    map.scrollWheelZoom.disable();

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    mapid.append(map);
  } catch (err) {}
};

const makeCharts = async (data) => {
  try {
    data = await data;

    if (!data) {
      return;
    }

    const transformedDataConfirmed = data[0].map((element) => {
      return element['Cases'];
    });
    const transformedLabels = data[0].map((element) => {
      return element['Date'].slice(0, 10);
    });

    const transformedDataRecovered = data[1].map((element) => {
      return element['Cases'];
    });

    const transformedDataDeaths = data[2].map((element) => {
      return element['Cases'];
    });

    const lastSevenDays = transformedLabels.splice(-7);
    const lastSevenConfirmed = transformedDataConfirmed.splice(-7);
    const lastSevenRecovered = transformedDataRecovered.splice(-7);
    const lastSevenDeaths = transformedDataDeaths.splice(-7);

    let ctx1 = document.getElementById('myChartWeek').getContext('2d');
    let myChart1 = new Chart(ctx1, {
      type: 'line',
      data: {
        labels: [...lastSevenDays],
        datasets: [
          {
            label: 'Total confirmed cases',
            data: [...lastSevenConfirmed],
            backgroundColor: ['rgba(62, 62, 62, .5)'],
            borderColor: ['rgba(62, 62, 62, 1)'],
            fill: false,
            borderWidth: 5,
            yAxisID: 'y-axis-1',
          },
          {
            label: 'Total recovered cases',
            data: [...lastSevenRecovered],
            backgroundColor: ['rgba(22, 199, 154, .5)'],
            borderColor: ['rgba(22, 199, 154, 1)'],
            fill: false,
            borderWidth: 5,
            yAxisID: 'y-axis-1',
          },
          {
            label: 'Total death cases',
            data: [...lastSevenDeaths],
            backgroundColor: ['rgba(240, 84, 84, .5)'],
            borderColor: ['rgba(240, 84, 84, 1)'],
            fill: false,
            borderWidth: 5,
            yAxisID: 'y-axis-1',
          },
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              type: 'linear',
              display: 'true',
              id: 'y-axis-1',
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    });

    let ctx = document.getElementById('myChart').getContext('2d');
    let myChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: [...transformedLabels],
        datasets: [
          {
            label: 'Total confirmed cases',
            data: [...transformedDataConfirmed],
            backgroundColor: ['rgba(62, 62, 62, .5)'],
            borderColor: ['rgba(62, 62, 62, 1)'],
            fill: false,
            borderWidth: 5,
            yAxisID: 'y-axis-1',
          },
          {
            label: 'Total recovered cases',
            data: [...transformedDataRecovered],
            backgroundColor: ['rgba(22, 199, 154, .5)'],
            borderColor: ['rgba(22, 199, 154, 1)'],
            fill: false,
            borderWidth: 5,
            yAxisID: 'y-axis-1',
          },
          {
            label: 'Total death cases',
            data: [...transformedDataDeaths],
            backgroundColor: ['rgba(240, 84, 84, .5)'],
            borderColor: ['rgba(240, 84, 84, 1)'],
            fill: false,
            borderWidth: 5,
            yAxisID: 'y-axis-1',
          },
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              type: 'linear',
              display: 'true',
              id: 'y-axis-1',
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    });
  } catch (err) {
    document
      .querySelector('.section-chart-week')
      .insertAdjacentHTML(
        'beforeend',
        '<h2>There was an error. Try again later</h2>'
      );
  }
};

const init = () => {
  try {
    getCountry(code);
    renderCasesSecion(getLive(country));
    makeCharts(getData(country));
    generateMap(getCoords(country));
  } catch (err) {
    console.log(err);
  }
};

init();
